import { Sparkles, Code, LayoutDashboard } from "lucide-react";
import { BentoGrid } from "@/components/ui/bento-grid";
import {
  Section,
  SectionContainer,
  SectionHeader,
  SectionTitle,
  SectionDescription,
  SectionContent,
} from "@/components/ui/section";

const defaultTiers = [
  {
    title: "Landing Page",
    price: "2 999",
    description: "Great for freelancers and small projects",
    icon: <Code />,
    color: "blue",
    cta: true,
    ctaText: "Contact for Quote",
    features: [
      {
        name: "Landing Page",
        description: "Responsive and modern design",
        included: true,
      },
      {
        name: "Basic SEO",
        description: "Optimize for search engines",
        included: true,
      },
      {
        name: "Performance Optimization",
        description: "Fast and efficient coding",
        included: true,
      },
      {
        name: "CMS Integration",
        description: "Limited CMS capabilities",
        included: false,
      },
    ],
  },

  {
    title: "Full Website",
    price: "4 999",
    description: "Ideal for startups and growing businesses",
    highlight: true,
    hasPersistentHover: true,
    badge: "Most Popular",
    icon: <LayoutDashboard />,
    color: "green",
    cta: true,
    ctaText: "Contact for Quote",
    features: [
      {
        name: "Full Website Development",
        description: "Custom UI/UX and advanced features",
        included: true,
      },
      {
        name: "Advanced SEO",
        description: "Comprehensive search engine optimization",
        included: true,
      },
      {
        name: "E-commerce Integration",
        description: "Shopify, WooCommerce, and more",
        included: true,
      },
      {
        name: "Priority Support",
        description: "Faster response time and maintenance",
        included: true,
      },
    ],
  },
  {
    title: "Custom",
    price: "5k+",
    description: "Tailored solutions for complex projects",
    icon: <Sparkles />,
    color: "purple",
    cta: true,
    ctaText: "Contact for Quote",
    features: [
      {
        name: "Custom Web Applications",
        description: "Scalable, high-performance apps",
        included: true,
      },
      {
        name: "API Development",
        description: "Custom API solutions and integrations",
        included: true,
      },
      {
        name: "Full-stack Development",
        description: "Frontend and backend expertise",
        included: true,
      },
      {
        name: "Dedicated Support",
        description: "Personalized assistance and SLAs",
        included: true,
      },
    ],
  },
];

function Pricing() {
  return (
    <Section id="pricing">
      <SectionContainer>
        <SectionHeader>
          <SectionTitle>Pricing</SectionTitle>
          <SectionDescription>
            Transparent pricing plans designed to fit your needs. Choose the
            right plan for your project.
          </SectionDescription>
        </SectionHeader>
        <SectionContent>
          <BentoGrid items={defaultTiers} variant="default" columns={3} />
        </SectionContent>
      </SectionContainer>
    </Section>
  );
}

export default Pricing;
